import { link } from "../data/links";
import { nodes } from "../data/nodes";

export const findShortestPathBFS = (startId, endId) => {
  const queue = [[startId]]; // Store paths as arrays
  const visited = new Set();

  // Build a Set of valid node IDs for O(1) lookup
  const validNodeIds = new Set(nodes.map(n => n.id));

  while (queue.length > 0) {
    const path = queue.shift(); // Get first path from queue
    const nodeId = path[path.length - 1]; // Last node in the path

    if (nodeId === endId) {
      return path; // Found the shortest path
    }

    if (!visited.has(nodeId)) {
      visited.add(nodeId);

      const neighbors = link[nodeId] || [];
      neighbors.forEach(neighbor => {
        // Only traverse to neighbors that exist in nodes.js
        if (validNodeIds.has(neighbor) && !visited.has(neighbor)) {
          queue.push([...path, neighbor]);
        }
      });
    }
  }

  return null;
};
